<template>
  <div>
    <div class="sidebar-mobile">
      <div class="sidebar-mobile__container">
        <template v-if="canContactTeam">
          <ContactTeamMobileItem :item="rm" modal-key="contactRM" v-if="rm"></ContactTeamMobileItem>
          <ContactTeamMobileItem :item="am" modal-key="contactAM" v-if="am"></ContactTeamMobileItem>
        </template>
        <div class="sidebar-mobile__menu-btn">
          <label for="toggle-menu">MENU</label>
        </div>
      </div>
    </div>

    <input type="checkbox" id="toggle-menu" v-model="showMenu">
    <NavMenuMobile></NavMenuMobile>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ContactTeamMobileItem from '../sidebar/nav-menu-items/ContactTeamMobileItem.vue';
  import NavMenuMobile from '../sidebar/NavMenuMobile.vue';

  export default {
    name: 'SidebarMobile',
    components: {
      ContactTeamMobileItem,
      NavMenuMobile,
    },
    data () {
      return {
        showMenu: false,
      }
    },
    computed: {
      ...mapGetters('main', ['permissions', 'am', 'rm', 'canContactTeam', 'displayMobileMenu']),
    },
    watch: {
      displayMobileMenu() {
        if (! this.displayMobileMenu) {
          this.showMenu = false;
        }
      },
      showMenu() {
        if (this.showMenu) {
          this.$store.dispatch('main/setDisplayMobileMenu', true);
        }
      }
    },
  };
</script>
